<template>
    <div id="detail-doctor">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">WikiAllergies EMR On Boarding Procedure</h4></div>
                </div>
            </div>
            <div class="">
               <p>WikiAllergies EMR On Boarding Procedure</p>
                <p>In order to let a user sending medication electronically, we would need to verify her identity as what she claims. We also need to verify her medical license.</p>
                <p>For physicians or midlevel's, setup at WikiAllergies.com physician account by following those steps below:</p>
                <ul>
                  <li>1. Register a doctor account at WikiAllergies.com and Clinic account at WikiAllergies.com. User need to look up NPI for each account at the public database link if they do not know the NPI.</li>
                  <li>2. User has to have access to a computer with Chrome browser or similar and a smart phone with the number matches that of the phone bill.</li>
                  <li>3. Go to UPDATE PROFILE on the left column next to the avatar.</li>
                  <li>4. Click on Account Setting, update Cell Phone number that matches the phone bill that will be uploaded at step (5).</li>
                  <li>5. Register provider with Surescripts at SURESCRIPTS STATUS > click on Deactivated to open "Create Provider Location".</li>
                  <li>
                    6. Click on EMR Setup tab, choose CREDENTIALS page and upload proof of.
                    <ul style="list-style-type: circle !important;">
                      <li style="list-style: circle !important;">Copy of active state issued medical license.</li>
                      <li style="list-style: circle !important;">Copy of past or current ABAI board certificates (optional, preferable).</li>
                    </ul>
                  </li>
                  <li>
                    7. Same at EMR Setup tab, choose ID proofing, upload current cell phone bill that matches user's name and cell phone number.
                  </li>
                  <li>
                    8. Go to Trizetto site link and setup and account with Trizetto for insurance billing.
                  </li>
                </ul>
                <p>
                  After having those information updated, we will send her a text message to link to a ID Proof service. User needs to complete ID biometric proof and knowledge base questionnaire completed. After user's identity is verified, we will activate WikiAllergies EMR and e-prescribe function.
                </p>
                <p>For WikiAllergies Staff</p>
                <ul>
                  <li>1. Verify phone number matches user name and phone number in the cell phone bill uploaded by user</li>
                  <li>2. Send a link for ID Proof to verified cell phone number from step (1)</li>
                  <li>3. Verify two (2) steps verifications are success: 1. Driver License, 2. Criminal Federal</li>
                  <li>3. Activate WikiAllergies EMR and e-prescribe</li>
                  <li>4. Let coding team know to register provider with Surescripts</li>
                  <li>5. Check with Trizetto to implement billing services</li>
                </ul>
            </div>

            <div slot="footer">
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
export default {
  name: 'DetailTextInfoUser',
  mixins: [DetailRegularUserMixin, CommonMixin],
  data () {
    return {
      modal: false
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style scoped="">
</style>
